import React from "react";
import { Box, Skeleton, Typography } from "@mui/material";

const SeatSkeleton = () => {
  const rows = [1, 2, 3, 4, 5, 6];
  const columns = ["A", "B", "C", "D", "E", "F"];

  const renderSeats = (rowIndex: number) => (
    <Box key={rowIndex} display="flex" gap={1} mb={2} justifyContent="center">
      {columns.map((col) => (
        <Skeleton
          key={col}
          variant="rectangular"
          width={30}
          height={40} // Increased height
          sx={{ bgcolor: "#e0e0e0", borderRadius: "6px" }} // Lighter color
        />
      ))}
    </Box>
  );

  return (
    <Box textAlign="center" mt={6}>
      {/* Cabin Arc Placeholder */}
      <Box
        mx="auto"
        width={220}
        height={120} // Increased height
        mb={3}
        sx={{ borderRadius: "50%/100% 100% 0 0", bgcolor: "#f0f0f0" }} // Light gray arc
      />

      {/* Seat Rows */}
      {rows.map((_, idx) => renderSeats(idx))}
    </Box>
  );
};

export default SeatSkeleton;
